import { EntityState } from '@ngrx/entity';
import { EmailConversation } from './models/email-conversation.model';
import { emailConversationEntityAdapter } from './adapters/email-conversation.adapter';
import { EmailMessage } from './models/email-message.model';
import { WrapUpsSubState } from '../common/models/wrap-up-sub-state.model';

export interface GenesysCloudEmailMessagesSubState {
  [conversationId: string]: EntityState<EmailMessage>;
}
export type ConversationsSubState = EntityState<EmailConversation>;

export interface GenesysCloudEmailConversationsState {
  conversations: ConversationsSubState;
  messages: GenesysCloudEmailMessagesSubState;
  wrapups: WrapUpsSubState;
}

export const initialConversationsSubState = (): ConversationsSubState => emailConversationEntityAdapter.getInitialState();
export const initialEmailMessagesSubState = (): GenesysCloudEmailMessagesSubState => ({});
export const initialWrapUpsSubState = (): WrapUpsSubState => ({});

export const initialState = (): GenesysCloudEmailConversationsState => ({
  conversations: initialConversationsSubState(),
  messages: initialEmailMessagesSubState(),
  wrapups: initialWrapUpsSubState()
});
